import {
  SET_QUIZ_ACTIVE,
  SYNC_QUIZ_SUCCESS,
  GET_QUIZ_SUCCESS,
  LOAD_QUIZ,
  SET_QUIZ,
  QUIZ_NEXT_PAGE,
  QUIZ_PREV_PAGE,
  SET_PROGRESS,
  UPDATE_PROGRESS,
  RESULTS_SUBMITTED_SUCCESS,
  RESULTS_SUBMITTED_FAILED,
  RESET_STORE,
  RESET_QUIZ_DATA,
  SET_PRIZES,
  TEAM_SCORES_UPDATED,
  NEW_USER_RESET,
  LOAD_DEBUG_STATE,
} from "../actionTypes";

const defaultProgress = {
  round: 1,
  position: 0,
  section: "intro",
  page: "intro",
  output: {
    mode: "intro",
    page: 0,
    position: 0,
  },
  musicActive: 0,
  constants: {},
};

const defaultState = {
  questionCount: 0,
  quizId: 0,
  quizName: "",
  quizConfig: {},
  quizActive: false,
  progress: defaultProgress,
  resultsSubmitted: false,
  resultsAmended: false,
  assignedPrizes: [],
};

const quiz = (state = defaultState, action, root) => {
  const { type, payload } = action;
  let progress = {};

  switch (type) {
    case SET_QUIZ_ACTIVE:
      return { ...state, quizActive: payload };
    case GET_QUIZ_SUCCESS:
      return state;
    case LOAD_QUIZ:
      if (state.progress.section === "intro") {
        progress = {
          ...state.progress,
          round: 0,
          position: 0,
          section: "welcome",
          page: "intro",
          output: { mode: "quiz", page: "" },
        };
      } else {
        state.progress.output = { mode: "quiz", page: "" };
        progress = state.progress;
      }
      // ChromeCast.loadQuiz(progress);

      return {
        ...state,
        progress: progress,
        quizActive: true,
      };

    case SYNC_QUIZ_SUCCESS:
      return {
        ...state,
        quizConfig: JSON.parse(payload.quizString),
      };
    case SET_QUIZ:
      let quizString = payload.quizString;
      delete payload.quizString;
      return {
        ...defaultState,
        assignedPrizes: state.assignedPrizes,
        ...payload,
        quizConfig: JSON.parse(quizString),
      };
    case QUIZ_NEXT_PAGE:
    case QUIZ_PREV_PAGE:
      return { ...state, progress: { ...state.progress, ...payload } };
    case SET_PROGRESS:
      return { ...state, progress: { ...defaultProgress, ...payload } };
    case UPDATE_PROGRESS:
      // console.log(payload);
      // console.error("UPDATE_PROGRESS", payload);
      // console.log({ ...state, progress: { ...state.progress, ...payload } });
      return { ...state, progress: { ...state.progress, ...payload } };
    case RESULTS_SUBMITTED_SUCCESS:
      return { ...state, resultsSubmitted: true, resultsAmended: false };
    case RESULTS_SUBMITTED_FAILED:
      return { ...state, resultsSubmitted: false };
    case TEAM_SCORES_UPDATED:
      return { ...state, resultsAmended: true };
    case RESET_QUIZ_DATA:
    case RESET_STORE:
      return { ...defaultState };
    case SET_PRIZES:
      return { ...state, assignedPrizes: payload };
    case NEW_USER_RESET:
      return { ...state, progress: { ...defaultState.progress } };
    case LOAD_DEBUG_STATE:
      console.log(payload);
      let debugState = payload.quiz;
      return { ...state, ...debugState };
    default:
      return state;
  }
};

export default quiz;
